import { z } from 'zod'

/** 角色 - 新增/更新 Response Schema */
export const upsertRoleResponseSchema = z.object({
  /** 角色代碼 */
  roleCode: z.string(),
  /** 角色名稱 */
  roleName: z.string()
})

/** 角色 - 新增/更新 Response */
export interface UpsertRoleResponse
  extends z.infer<typeof upsertRoleResponseSchema> {}
